"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6416],{

/***/ 50000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ common_LockedClientRowPlaceholder; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(36557);
;// CONCATENATED MODULE: ./components/User/_components/common/LockedClientRowPlaceholder/index.styles.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var Row = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "edb1r6n3"
} : 0)("display:flex;align-items:center;gap:8px;padding:16px;background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.colors.white;
}, ";border-radius:8px;" + ( true ? "" : 0));
var Dot = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "edb1r6n2"
} : 0)("width:8px;height:8px;border-radius:50%;flex-shrink:0;background-color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.zinc_200;
}, ";margin:5px;" + ( true ? "" : 0));
var InfoSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "edb1r6n1"
} : 0)( true ? {
  name: "pl5a4v",
  styles: "display:flex;flex-direction:column;gap:8px;flex:1"
} : 0);
var Bar = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "edb1r6n0"
} : 0)("height:14px;width:", function (_ref3) {
  var width = _ref3.width;
  return width;
}, "px;border-radius:4px;background-color:", function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.zinc_200;
}, ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./components/User/_components/common/LockedClientRowPlaceholder/index.tsx




var LockedClientRowPlaceholder = function LockedClientRowPlaceholder() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dot, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InfoSection, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Bar, {
        width: 120
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Bar, {
        width: 180
      })]
    })]
  });
};

/* harmony default export */ var common_LockedClientRowPlaceholder = (LockedClientRowPlaceholder);

/***/ }),

/***/ 96763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ common_Star; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(55830);
// EXTERNAL MODULE: ../../packages/pds-react/src/index.ts + 66 modules
var src = __webpack_require__(61810);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(62350);
// EXTERNAL MODULE: ./utils/api.ts + 1 modules
var api = __webpack_require__(74457);
;// CONCATENATED MODULE: ./hooks/mutations/client/useUpdateClientLike.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var updateClientLike = function updateClientLike(_ref) {
  var clientId = _ref.clientId;
  return api/* api.put */.h.put('/client/like', {
    clientId: clientId
  });
};

var useUpdateClientLike = function useUpdateClientLike(options) {
  return (0,useMutation/* useMutation */.D)(updateClientLike, _objectSpread({}, options));
};

/* harmony default export */ var client_useUpdateClientLike = (useUpdateClientLike);
// EXTERNAL MODULE: ./hooks/queries/client/useClientList.ts
var useClientList = __webpack_require__(9416);
// EXTERNAL MODULE: ../../node_modules/@radix-ui/react-tooltip/dist/index.mjs
var dist = __webpack_require__(24990);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(36557);
// EXTERNAL MODULE: ./constants/zIndex.ts
var zIndex = __webpack_require__(90122);
;// CONCATENATED MODULE: ./components/User/_components/ui/Tooltip/index.styles.ts



/* pds IconTooltip과 같은 생김새를 쓰되, 아이콘이 아닌 임의의 요소를 감쌀 수 있게 한다 */

var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(dist/* Content */.VY,  true ? {
  target: "eo6g8f60"
} : 0)("z-index:", zIndex/* Z_INDEX.tooltip */.k.tooltip, ";padding:8px;background:", function (_ref) {
  var theme = _ref.theme;
  return theme.colors.zinc_500;
}, ";border-radius:4px;box-shadow:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.elevation.md;
}, ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./components/User/_components/ui/Tooltip/index.tsx






/**
 * 임의의 요소에 붙이는 툴팁.
 *
 * pds의 IconTooltip은 물음표 아이콘을 스스로 그려서 버튼 같은 기존 요소에는 쓸 수 없다.
 * 생김새는 IconTooltip과 동일하게 맞춰 화면 간 편차가 없게 한다.
 */
var Tooltip = function Tooltip(_ref) {
  var content = _ref.content,
      _ref$side = _ref.side,
      side = _ref$side === void 0 ? 'top' : _ref$side,
      children = _ref.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Provider */.zt, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist/* Root */.fC, {
      delayDuration: 200,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Trigger */.xz, {
        asChild: true,
        children: children
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Portal */.h_, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Content, {
          side: side,
          sideOffset: 8,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            variant: "sm-medium",
            color: "white",
            textAlign: "center",
            children: content
          })
        })
      })]
    })
  });
};

/* harmony default export */ var ui_Tooltip = (Tooltip);
;// CONCATENATED MODULE: ./components/User/_components/common/Star/index.styles.ts


/**
 * 별을 그냥 아이콘으로만 두면 표시등인지 버튼인지 구분되지 않는다.
 * 커서·hover 배경·포커스 링으로 "누를 수 있는 것"임을 먼저 알린다.
 */
var StarButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "e15te6vd0"
} : 0)("display:flex;align-items:center;justify-content:center;padding:4px;border-radius:4px;cursor:pointer;transition:background-color 0.15s ease-in-out;&:hover,&:focus-visible{background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.colors.zinc_100;
}, ";}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ./components/User/_components/common/Star/index.tsx










var Star = function Star(_ref) {
  var like = _ref.like,
      clientId = _ref.clientId,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 14 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 14 : _ref$height;

  var _useState = (0,react.useState)(like),
      isLike = _useState[0],
      setIsLike = _useState[1];

  var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
  var toast = (0,src/* useToast */.pm)();

  var _useUpdateClientLike = client_useUpdateClientLike(),
      mutate = _useUpdateClientLike.mutate;

  var handleClickLike = function handleClickLike(e) {
    // 카드 전체가 클릭 대상인 목록에서도 별 토글이 이동으로 새지 않게 한다.
    e.stopPropagation();
    var previous = isLike;
    setIsLike(!previous);
    mutate({
      clientId: clientId
    }, {
      // 실패하면 낙관적으로 뒤집은 표시를 되돌린다. 되돌리지 않으면
      // 화면은 켜져 있는데 서버는 꺼져 있는 상태가 그대로 남는다.
      onError: function onError() {
        setIsLike(previous);
        toast('즐겨찾기 변경에 실패했어요. 잠시 후 다시 시도해 주세요.');
      },
      // 좋아요는 고객 목록의 1차 정렬 기준이라 행 순서까지 바뀐다.
      onSettled: function onSettled() {
        queryClient.invalidateQueries(useClientList/* CLIENT_LIST_QUERY_KEY */.Vt);
      }
    });
  }; // 목록을 다시 받아오면(정렬·페이지 이동 포함) 서버 값으로 맞춘다.


  react.useEffect(function () {
    setIsLike(like);
  }, [like, setIsLike]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ui_Tooltip, {
    content: isLike ? '상단 고정 해제' : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: "\uC0C1\uB2E8 \uACE0\uC815"
    }),
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StarButton, {
      type: "button",
      onClick: handleClickLike,
      "aria-pressed": isLike,
      "aria-label": "\uC990\uACA8\uCC3E\uAE30",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
        icon: isLike ? 'ph:star-fill' : 'ph:star-light',
        color: isLike ? 'star' : 'zinc_300',
        size: {
          width: width,
          height: height
        }
      })
    })
  });
};

/* harmony default export */ var common_Star = (Star);

/***/ }),

/***/ 54148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ui_BoxAccordion; }
});

// EXTERNAL MODULE: ../../node_modules/@radix-ui/react-accordion/dist/index.mjs + 1 modules
var dist = __webpack_require__(75694);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/pds-react/src/index.ts + 66 modules
var src = __webpack_require__(61810);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(36557);
// EXTERNAL MODULE: ./styles/keyframes/slide.ts
var slide = __webpack_require__(77991);
;// CONCATENATED MODULE: ./components/User/_components/ui/BoxAccordion/index.styles.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }




var AccordionRoot = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(dist/* Root */.fC,  true ? {
  target: "e1jx4kdg4"
} : 0)( true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0);
var AccordionItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(dist/* Item */.ck,  true ? {
  target: "e1jx4kdg3"
} : 0)("overflow:hidden;border:1px solid ", function (_ref) {
  var theme = _ref.theme;
  return theme.colors.zinc_200;
}, ";background:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.white;
}, ";border-radius:8px;" + ( true ? "" : 0));
var AccordionTrigger = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(dist/* Trigger */.xz,  true ? {
  target: "e1jx4kdg2"
} : 0)("display:flex;width:100%;align-items:center;padding:16px;gap:8px;&[data-state='open']{border-bottom:1px solid ", function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.zinc_200;
}, ";}&.nothing{border-bottom:0;}" + ( true ? "" : 0));
var ChevronIcon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Icon */.JO,  true ? {
  target: "e1jx4kdg1"
} : 0)( true ? {
  name: "mtyh4w",
  styles: "[data-state='closed'] &{transform:rotate(180deg);}transition:transform 0.15s ease-in-out"
} : 0);
var AccordionContent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(dist/* Content */.VY,  true ? {
  target: "e1jx4kdg0"
} : 0)("&[data-state='closed']{animation:", (0,slide/* slideUp */.i)('var(--radix-collapsible-content-height)'), " 0.15s ease-in-out;}&[data-state='open']{display:flex;flex-direction:column;animation:", (0,slide/* slideDown */.q)('var(--radix-collapsible-content-height)'), " 0.15s ease-in-out;}background:", function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.zinc_50;
}, ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./components/User/_components/ui/BoxAccordion/index.tsx







var BoxAccordion = function BoxAccordion(_ref) {
  var title = _ref.title,
      children = _ref.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionRoot, {
    type: "single",
    defaultValue: children ? 'item-1' : '',
    collapsible: true,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AccordionItem, {
      value: "item-1",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* Header */.h4, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionTrigger, {
          className: children ? '' : 'nothing',
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
            justifyContent: "space-between",
            alignItems: "center",
            gap: 8,
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              children: title
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ChevronIcon, {
              icon: "ph:caret-up",
              size: 19
            })]
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionContent, {
        children: children
      })]
    })
  });
};

/* harmony default export */ var ui_BoxAccordion = (BoxAccordion);

/***/ }),

/***/ 92872:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ localStorageKey; }
/* harmony export */ });
var localStorageKey = {
  userSortDropdown: 'userSortDropdown',
  fileOrLinkDropdown: 'fileOrLinkDropdown',
  isPdfViewerFirstVisit: 'isPdfViewerFirstVisit',
  fileBulkDropdown: 'fileBulkDropdown',
  fileMainDropdown: 'fileMainDropdown',
  fileMainViewType: 'fileMainViewType',
  linkMainDropdown: 'linkMainDropdown'
};

/***/ }),

/***/ 89089:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ pulse; }
/* harmony export */ });
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28165);
/* harmony import */ var _pairy_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97223);


var pulse = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)("animation:", _pairy_styles__WEBPACK_IMPORTED_MODULE_0__/* .animation.pulse */ .oQ.pulse('79, 88, 96'), " 2.5s infinite;" + ( true ? "" : 0),  true ? "" : 0);

/***/ })

}]);